module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAS5JREFUWEft1tEJgzAQBuCLg5Tu0TenEKG0doHqJOoCtaUgTuFb9ygdRItCIKL1ktwpQuNrcvHzz5EoYOOP2LgPHJC6Qy7B/0swqvyW+tWU+iKoB2036kEHROJFEzw+DjvKFlFrn6fXR13DHTPURF2CLkHdBM6VnwqAuJvfAmT3oE50a+fmsfSgipMv40KSgVM4TiQJOMI1kPc4D65cSGvgFK4I674Ho9LPuJBWwDmcTI4LaQzUwXEijYAmOC6kNtAGx4HUAlJwVCQK5MBRkLNATpwt8idwCZwNchK4JM4UOQKugTNBDoBr4nSRA+Cl9OPWg7QvbiCXdyvHf93cGuq1KBpIbmGdyfmjLe6RAPu1cGqSAuCt4rox9BxcOj1sfQfEEsLGXYJYQtj45hP8AuVd0SkpOUOMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/home/top_h.png
// module id = 3Gdt
// module chunks = 101